const isFileSvg = path => (path || '').toLowerCase().split('.').pop() === 'svg';

export default isFileSvg;
